import { createTheme } from '@mui/material/styles';

import { components } from './components';

const baseTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 725,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: '"Quicksand", "Helvetica", "Arial", sans-serif',
    fontSize: 15,
  },
  components,
});

export const appTheme = createTheme(baseTheme, {
  typography: {
    caption2: {
      ...baseTheme.typography.caption,
      fontSize: '12px',
      fontWeight: 500,
    },
  },
});
